import type { TallyCase } from "../../contract"
import { Fold } from "../Fold"
import { useAnswerSession } from "../session"
import { useBlockScope } from "./context"

interface TallyProps { won: number; remanded: number; lost: number; total: number; cases: TallyCase[] }

/** Who won on similar facts, with the decisions behind the count. */
export function Tally({ won, remanded, lost, total, cases }: TallyProps) {
  const { turn, sources } = useBlockScope()
  const openSource = useAnswerSession((s) => s.openSource)
  return (
    <>
      <p className="pr">
        Across {total} decisions on similar facts, the taxpayer won {won}, the matter was sent back in {remanded}, and
        the department won {lost}.
      </p>
      {cases.length ? (
        <Fold label={`See ${cases.length === total ? `all ${total}` : `${cases.length} of ${total}`}`}>
          <ul className="more">
            {cases.map((c, i) => {
              const meta = [c.court, c.year ? String(c.year) : "", c.outcome].filter(Boolean).join(" · ")
              return (
                <li key={i}>
                  {sources[c.source_id] ? (
                    <button type="button" onClick={(e) => openSource({ turn, id: c.source_id, from: e.currentTarget })}>
                      {c.name}
                    </button>
                  ) : (
                    <span>{c.name}</span>
                  )}
                  <span className="m">{meta}</span>
                </li>
              )
            })}
          </ul>
        </Fold>
      ) : null}
    </>
  )
}
